import axios from 'axios'
import {API_URL} from '../../../utils/consts'

export default {
    async generateDocument(format, type, monetization, contact) {
        try {
            let body = {format, type}
            if (monetization) {
                body = {...body, monetization}
            }
            if (contact.id) {
                body = {...body, contact}
            }
            const response = await axios.post(`${API_URL}/document/generate`, body, {headers: {'content-type': 'application/json'}, responseType: 'blob'})
            return response
        } catch (e) {
            throw e
        }
    }
}
